import React from 'react'
import classes from './index.module.scss';
import { IconButton } from '@material-ui/core';
import Icon from '@mdi/react';
import { mdiMagnify } from '@mdi/js';

const SearchBox = (props: any) => {
  return (
    <div className={classes.searchBox} >
      <input className={classes.input} placeholder="جستجوی کالا" />
      <IconButton className={classes.icon}>
        <Icon path={mdiMagnify} size={1} color={"#fff"} />
      </IconButton>
    </div>
  )
}

export default SearchBox